import { render, staticRenderFns } from "./AttachmentsTree.vue?vue&type=template&id=c54c3170&scoped=true&"
import script from "./AttachmentsTree.vue?vue&type=script&lang=js&"
export * from "./AttachmentsTree.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentsTree.vue?vue&type=style&index=0&id=c54c3170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54c3170",
  null
  
)

export default component.exports